import { withInstall } from '@bigin/utils'

import PageHeader from './src/page-header.vue'

export const BPageHeader = withInstall(PageHeader)
export default BPageHeader

export * from './src/page-header'
